import React, {FC} from "react";

const ReservesOnlyForHighSla: FC = () => {

    // @ts-ignore
    return (
        <div className={`inline-flex min-w-fit md:min-w-80 w-full px-4 py-2 rounded-sm text-sm bg-white border border-gray-200 text-gray-600`}>
            <div className="flex w-full justify-between items-start">
                <div className="flex">
                    <svg className="w-4 h-4 flex-shrink-0 fill-current text-yellow-500 mt-[3px] mr-3"
                         viewBox="0 0 16 16">
                        <path
                            d="M8 0C3.6 0 0 3.6 0 8s3.6 8 8 8 8-3.6 8-8-3.6-8-8-8zm1 12H7V7h2v5zM8 6c-.6 0-1-.4-1-1s.4-1 1-1 1 .4 1 1-.4 1-1 1z"></path>
                    </svg>
                    <div className="text-xs	">
                        <div>Применение фильтра доступно для <a href="/a/billing/plans" className="mb-2" style={{color: "rgb(37 99 235)"}} rel="noreferrer" target="_blank">коммерческих тарифов</a>.</div>
                    </div>
                </div>
            </div>
        </div>
    )
}

export default ReservesOnlyForHighSla
